// Bangladesh Cities and Coordinates
export const bangladeshCities = [
  {
    id: 'dhaka',
    name: 'Dhaka',
    district: 'Dhaka',
    lat: 23.8103,
    lng: 90.4125,
    population: '8-10 million',
    region: 'Central',
  },
  {
    id: 'chittagong',
    name: 'Chittagong',
    district: 'Chattogram',
    lat: 22.3569,
    lng: 91.7832,
    population: '3-4 million',
    region: 'Southeast',
  },
  {
    id: 'sylhet',
    name: 'Sylhet',
    district: 'Sylhet',
    lat: 24.9074,
    lng: 91.8734,
    population: '0.5-1 million',
    region: 'Northeast',
  },
  {
    id: 'rajshahi',
    name: 'Rajshahi',
    district: 'Rajshahi',
    lat: 24.3745,
    lng: 88.6042,
    population: '0.4-0.6 million',
    region: 'Northwest',
  },
  {
    id: 'khulna',
    name: 'Khulna',
    district: 'Khulna',
    lat: 22.8456,
    lng: 89.5403,
    population: '0.6-0.8 million',
    region: 'Southwest',
  },
  {
    id: 'barisal',
    name: 'Barisal',
    district: 'Barishal',
    lat: 22.7010,
    lng: 90.3563,
    population: '0.3-0.5 million',
    region: 'South-Central',
  },
  {
    id: 'rangpur',
    name: 'Rangpur',
    district: 'Rangpur',
    lat: 25.7461,
    lng: 89.2752,
    population: '0.3-0.5 million',
    region: 'North',
  },
  {
    id: 'mymensingh',
    name: 'Mymensingh',
    district: 'Mymensingh',
    lat: 24.7465,
    lng: 90.4081,
    population: '0.4-0.6 million',
    region: 'North-Central',
  },
  {
    id: 'gazipur',
    name: 'Gazipur',
    district: 'Gazipur',
    lat: 23.9998,
    lng: 90.4167,
    population: '2-3 million',
    region: 'Central (near Dhaka)',
  },
  {
    id: 'narayanganj',
    name: 'Narayanganj',
    district: 'Narayanganj',
    lat: 23.6432,
    lng: 90.5020,
    population: '1-2 million',
    region: 'Central (near Dhaka)',
  },
];

// Sport venues and grounds in major Bangladesh cities
export const sportVenues = {
  dhaka: [
    { name: 'Bangabandhu National Stadium', area: 'Motijheel', lat: 23.8035, lng: 90.4235 },
    { name: 'Sher-e-Bangla National Cricket Stadium', area: 'Mirpur', lat: 23.8286, lng: 90.3850 },
    { name: 'Gulshan Club', area: 'Gulshan', lat: 23.8080, lng: 90.4127 },
    { name: 'BARISUPER Football Ground', area: 'Gabtoli', lat: 23.8753, lng: 90.3600 },
    { name: 'Dhanmondi Lake Sports Complex', area: 'Dhanmondi', lat: 23.7481, lng: 90.3721 },
    { name: 'Banani Sports Ground', area: 'Banani', lat: 23.8234, lng: 90.4163 },
  ],
  chittagong: [
    { name: 'Zahur Ahmed Chowdhury Stadium', area: 'Halishahar', lat: 22.3456, lng: 91.8234 },
    { name: 'Chittagong Club', area: 'GEC', lat: 22.3789, lng: 91.8456 },
    { name: 'Agrabad Sports Ground', area: 'Agrabad', lat: 22.3234, lng: 91.8123 },
  ],
  sylhet: [
    { name: 'Sylhet Osmani Cricket Stadium', area: 'Sylhet', lat: 24.9234, lng: 91.8567 },
    { name: 'Sylhet Sports Ground', area: 'Sylhet', lat: 24.8945, lng: 91.8834 },
  ],
};

// Get nearby cities based on coordinates
export const getNearestCity = (lat, lng) => {
  let nearest = bangladeshCities[0];
  let minDistance = Infinity;

  bangladeshCities.forEach((city) => {
    const distance = Math.sqrt(
      Math.pow(city.lat - lat, 2) + Math.pow(city.lng - lng, 2)
    );
    if (distance < minDistance) {
      minDistance = distance;
      nearest = city;
    }
  });

  return nearest;
};

// Get city by name
export const getCityByName = (name) => {
  return bangladeshCities.find(
    (city) => city.name.toLowerCase() === name.toLowerCase() ||
    city.id === name.toLowerCase()
  );
};

// Get all cities in a specific region
export const getCitiesByRegion = (region) => {
  return bangladeshCities.filter((city) => city.region === region);
};

export default {
  bangladeshCities,
  sportVenues,
  getNearestCity,
  getCityByName,
  getCitiesByRegion,
};
